import React from "react";
import { Avatar, Paper, Stack, Typography, alpha } from "@mui/material";
import ManageSearchOutlinedIcon from "@mui/icons-material/ManageSearchOutlined";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

const SubscriptionEmptyView = ({ paperBorderSx }) => {
  return (
    <Paper
      elevation={0}
      sx={{
        ...paperBorderSx,
        flex: 1,
        minHeight: { xs: 360, sm: 420 },
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        p: { xs: 3, sm: 5 },
      }}
    >
      <Avatar
        variant='rounded'
        sx={{
          width: 72,
          height: 72,
          borderRadius: 4,
          mb: 2.5,
          bgcolor: (t) => alpha(t.palette.primary.main, 0.08),
          color: "primary.main",
        }}
      >
        <ManageSearchOutlinedIcon sx={{ fontSize: 36 }} />
      </Avatar>

      <Typography variant='h6' fontWeight={700} sx={{ mb: 1 }}>
        Find a subscription to get started
      </Typography>

      <Typography
        variant='body2'
        color='text.secondary'
        sx={{ maxWidth: 460, mb: 3 }}
      >
        Search by organization name or subscription owner's email to view and
        manage subscription details.
      </Typography>

      <Stack spacing={1.5} alignItems='flex-start'>
        {[
          "Subscription plan and status",
          "Pricing, discounts and renewal",
          "Billing details and history",
        ].map((item) => (
          <Stack key={item} direction='row' spacing={1} alignItems='center'>
            <CheckCircleOutlineIcon
              sx={{
                fontSize: 17,
                color: "success.main",
              }}
            />

            <Typography variant='body2' color='text.secondary'>
              {item}
            </Typography>
          </Stack>
        ))}
      </Stack>

      <Typography variant='caption' color='text.disabled' sx={{ mt: 3 }}>
        Use the search field above to begin.
      </Typography>
    </Paper>
  );
};

export default SubscriptionEmptyView;
